//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionEditAIFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 21V16.09L14.09 4.99998L19 9.90998L7.91 21H3Z" fill="currentColor" /><path d="M15.51 3.57998L16.92 2.16998L21.83 7.07998L20.42 8.48998L15.51 3.57998Z" fill="currentColor" /><path d="M18.4831 14L19.7639 16.2024L21.9662 17.4831L19.7639 18.7639L18.4831 20.9662L17.2024 18.7639L15 17.4831L17.2024 16.2024L18.4831 14Z" fill="currentColor" /></svg>;
}
export default IconActionEditAIFill;